module.exports = __webpack_public_path__ + "media/components/Marketing/Root/Images/Section5/Devops-d570c61485dda552bb0e3dc25cb8a2cb.svg";